<div class="logs">
    <div
        [class.archived-log]="selectedLine.__typename === 'ArchivedOrderLine'"
        [class.log]="selectedLine.__typename === 'OrderLine'"
        class="header"
    >
        @if (selectedLine.__typename === "OrderLine") {
            <div>Source</div>
        }
        <div>Message</div>
        <div>Timestamp</div>
    </div>
    <mat-divider></mat-divider>
    @for (log of logs; track log) {
        <div>
            @switch (log.__typename) {
                @case ("OrderLineLog") {
                    <div class="log">
                        <span class="source">
                            {{ log.source }}
                        </span>
                        <span class="message">
                            {{ log.message }}
                        </span>
                        <span class="timestamp" [matTooltip]="log.timestampUtc">
                            {{ log.timestampUtc | date: "short" }} ({{ log.timestampUtc | fromNow }})
                        </span>
                        @if (log.details) {
                            <div class="details details-simple">
                                <td colspan="2">
                                    <pre><code><admin-linkified-text [text]="log.details" /></code></pre>
                                </td>
                            </div>
                        }
                    </div>
                }
                @case ("OrderLineApplicationInsightsLog") {
                    <div class="log">
                        <span class="source">
                            {{ log.cloudRoleName }}
                            {{ log.cloudRoleInstance }}
                        </span>
                        <span class="message">
                            @if (log.success) {
                                <div>
                                    Render completed in {{ log.duration | number }} ms
                                    @if (log.duration > 60000) {
                                        ({{log.duration / 60000 | number:'1.0-0'}} minutes)
                                    }
                                </div>
                            }
                            @if (!log.success) {
                                <div class="error-message">
                                    <mat-icon color="warn">warning</mat-icon> Render
                                    failed after {{ log.duration }} ms
                                    @if (log.duration > 60000) {
                                        ({{log.duration / 60000 | number:'1.0-0'}} minutes)
                                    }
                                </div>
                            }
                        </span>
                        <span [matTooltip]="log.timestampUtc" class="timestamp">
                            {{ log.timestampUtc | date: "short" }} ({{ log.timestampUtc | fromNow }})
                        </span>
                        <div class="details">
                            @for (appInsightLog of mergeApplicationInsightsLogs(log); track $index) {
                                <div class="exception">
                                    <span class="severityLevel">
                                        {{ appInsightLog.severityLevel }}
                                    </span>
                                    <div class="messages">
                                        <pre><code><admin-linkified-text
                                            [text]="appInsightLog.message" /></code></pre>
                                        @if (appInsightLog.exception) {
                                            <div class="exception-details">
                                                @for (message of extractInnerExceptionMessages(appInsightLog.exception); track $index) {
                                                    <div class="inner-exception-message">
                                                        <span>↳</span>
                                                        <span><pre><code><admin-linkified-text [text]="message" /></code></pre></span>
                                                    </div>
                                                }
                                            </div>
                                            <admin-application-insights-log-details
                                                [exception]="appInsightLog.exception"></admin-application-insights-log-details>
                                        }
                                    </div>

                                    @if (canViewApplicationInsights()) {
                                        @if (appInsightLog.openQueryUrl; as openLogUrl) {
                                            <button
                                                matTooltip="Open query in Application insights"
                                                mat-icon-button
                                                (click)="openApplicationInsightsForLog(openLogUrl)">
                                                <mat-icon>open_in_new</mat-icon>
                                            </button>
                                        }
                                    }
                                </div>
                            }
                            @empty {
                                <span>No exceptions or traces found</span>
                            }
                        </div>
                    </div>
                }
                @case ("ArchivedOrderLineLog") {
                    <div class="archived-log">
                        <span class="message">
                            <div>
                                Status changed to
                                <span class="status">{{ log.value }}</span>
                            </div>
                            <div>
                                {{ log.message }}
                            </div>
                        </span>
                        <span class="timestamp" [matTooltip]="log.timestampUtc">
                            {{ log.timestampUtc | date: "short" }} ({{ log.timestampUtc | fromNow }})
                        </span>
                    </div>
                }
            }
        </div>
        <mat-divider></mat-divider>
    }
</div>
